export default {
  SET_SECURITYGROUPS: 'setSecurityGroups',
  SET_SELECTED_SECURITYGROUP: 'setSelectedSecurityGroup',
  SET_FIELD_TENANTS: 'setFieldTenants',
  HIDE_EDIT_FIELDS: 'hideEditFields',
}